import { message } from 'antd';
import { APIError } from '../models';

export function getApiError(reason: any): APIError {
  const response = reason?.response;
  let apiError = response?.data as APIError;

  if (!apiError) {
    apiError = new APIError();
    apiError.code = '99999';
    apiError.message = 'Bilinmeyen hata.';
    apiError.status = response?.statusCode || 500;
    apiError.traceId = '0000';
  }

  return apiError;
}

export function apiErrorMessage(reason: any) {
  const apiError = getApiError(reason);
  message.error(`${apiError.message}`);
}
